import { CompactUser } from "../../../../core/CompactModels"
import DataItem from "../../../../models/DataItem"

export default interface BalanceTransaction {
    id?: string
    type?: BalanceTransactionTypes
    party?: BalanceTransactionParties
    techId?: string
    tech?: CompactUser
    sourceId?: string
    source?: DataItem
    amount?: number
    creatorUserId?: string
    creatorUser?: CompactUser
    createdAt?: Date
    customDate?: boolean
    timezone?: string
    transactionDate?: Date
    description?: string
}

export enum BalanceTransactionTypes {
    Receive = 1,
    Pay = 2
}

export enum BalanceTransactionParties {
    Technician = 1,
    Source = 2
}
